import { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { plannerApi } from "./plannerApi";

export const ArchiveDrawer = ({ open, onClose, onChanged }) => {
  const [archive, setArchive] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await plannerApi.listArchive();
      setArchive(res.data || []);
    } catch {
      toast.error("Failed to load archive");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (open) load(); }, [open]);

  const deleteTour = async (id) => {
    if (!window.confirm("Permanently delete this tour? This cannot be undone.")) return;
    try {
      await plannerApi.deleteTour(id);
      toast.success("Permanently deleted");
      load();
      onChanged();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to delete");
    }
  };

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="bg-white w-full sm:max-w-md overflow-y-auto" data-testid="archive-drawer">
        <SheetHeader>
          <SheetTitle className="text-slate-800">Archive — Cancelled Tours</SheetTitle>
        </SheetHeader>
        <div className="mt-4 space-y-2">
          {loading && <p className="text-sm text-slate-400">Loading…</p>}
          {!loading && archive.length === 0 && <p className="text-sm text-slate-300">Archive is empty.</p>}
          {archive.map((t) => (
            <div key={t.id} className="flex items-center justify-between rounded-md border border-slate-200 px-3 py-2" data-testid={`archive-row-${t.id}`}>
              <div className="text-sm text-slate-600">
                <span className="font-medium text-slate-700">{t.parentName}</span>
                <span className="text-slate-400"> · {t.date} {t.startTime}</span>
              </div>
              <Button size="sm" variant="ghost" className="text-[#C97B7B] hover:bg-[#C97B7B]/10" onClick={() => deleteTour(t.id)} data-testid={`archive-delete-${t.id}`}>
                <Trash2 className="w-3.5 h-3.5 mr-1" /> Delete
              </Button>
            </div>
          ))}
        </div>
        <div className="mt-6 flex justify-end">
          <Button variant="outline" onClick={onClose} data-testid="archive-close-btn">Close</Button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
